import { useCallback, useRef, useSyncExternalStore } from 'react';
import { localDrafts } from './localDrafts';

export function useLocalDraft(actor, kind, id) {
  const snapshot = useRef(null);
  const subscribe = useCallback(listener => localDrafts.subscribeDraft(kind, id, listener), [kind, id]);
  const read = useCallback(() => {
    const record = localDrafts.get(actor, kind, id);
    const ready = localDrafts.isReady(actor);
    const open = ready && localDrafts.isOpen(id);
    if (!snapshot.current || snapshot.current.record !== record || snapshot.current.ready !== ready || snapshot.current.open !== open) {
      snapshot.current = { record, ready, open };
    }
    return snapshot.current;
  }, [actor, kind, id]);
  return useSyncExternalStore(subscribe, read, read);
}
